
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/angel-investors/[slug]",
      function () {
        return require("private-next-pages/angel-investors/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/angel-investors/[slug]"])
      });
    }
  